<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="searchValue"
          />
          <label class="search-label">帐号</label>
          <Select
            v-model="userName"
            class="search-input"
            clearable
            style="width: 180px"
          >
            <Option
              v-for="item in UserIds"
              :value="item.username"
              :key="item.username"
              >{{ item.username }}</Option
            >
          </Select>
          <Button @click="handleButtonSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables/table-only.vue'
import { eventList, getAllUser } from '@/api/data'
export default {
  name: 'event',
  components: {
    Tables
  },
  data () {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      searchValue: '',
      UserIds: [],
      userName: '',
      tableLoading: true,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '帐号',
          key: 'username',
          width: 200,
          editable: true
        },
        {
          title: '用户名',
          key: 'realName',
          width: 200,
          editable: true
        },
        {
          title: '操作',
          key: 'msg',
          editable: true
        },
        { title: '操作时间', key: 'create_time', width: 150, editable: true }
      ],
      tableData: []
    }
  },
  methods: {
    changePage (page) {
      this.page = page
      this.handleSearch()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    getAllUser () {
      getAllUser()
        .then((res) => {
          if (res.data.code == 200) {
            this.UserIds = res.data.data.records
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    handleButtonSearch(){
      this.page = 1
      this.handleSearch()
    },
    handleSearch () {
      this.setTableLoading(true)
      let params = {
        keyword: this.searchValue,
        page: this.page,
        pageSize: this.pageSize,
        username: this.userName
      }
      eventList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.setTableLoading(false)
      })
    },
    setTableLoading (state) {
      this.tableLoading = state
    }
  },
  mounted () {
    this.handleSearch()
    this.$nextTick(() => {
      this.getAllUser()
    })
  }
}
</script>
